export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--5-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index2.vue?vue&type=style&index=0&id=41af1783&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/skip/index2.vue?vue&type=style&index=0&id=41af1783&prod&scoped=true&lang=css&
// module id = Cm/4
// module chunks = 202